import * as z from "zod";
import { array, literal, object, string } from "zod";
import { ContentType } from "../../conversation";
import { BaseMessageDbParser } from "../base-conversation-message-db-parser";
import {
  AutoGeneratedFieldsSchema,
  BaseActionableContentMessageSchema,
} from "../message-parser-utils";
export const FunctionCallSchema = object({
  name: string(),
  arguments: string(),
});

export type FunctionCall = z.infer<typeof FunctionCallSchema>;

export const ToolCallMessageSchema = BaseActionableContentMessageSchema.extend({
  contentType: literal(ContentType.TOOL_CALL),
  structuredContent: array(
    object({
      id: string(),
      type: literal("function"),
      function: FunctionCallSchema,
    }),
  ).optional(),
});

export const ToolCallErrorMessageSchema = BaseMessageDbParser.extend({
  contentType: literal(ContentType.TOOL_CALL_ERROR),
  structuredContent: object({ error: string() }).optional(),
});

export const ToolCallMessageDbParser = ToolCallMessageSchema.merge(
  AutoGeneratedFieldsSchema,
);
export type ToolCallMessage = z.infer<typeof ToolCallMessageDbParser>;
export const ToolCallErrorMessageDbParser = ToolCallErrorMessageSchema.merge(
  AutoGeneratedFieldsSchema,
);
